import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
// import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
// import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Controller, useForm, useFormContext } from 'react-hook-form';
import { IoMdCloseCircle } from 'react-icons/io';
import { MdOutlineImage } from 'react-icons/md';
import { authorizedServerFetch } from 'actions/server.actions';
import getQualifiedImageUrl from '../../utils/imageUrlProcessor';
import TextArea from '@ui/TextArea';
import RecipientSelector from './celebrateRecipientSelector';
import Image from 'next/image';

// const StyledGalleryItem = styled(Grid)(({ theme }) => ({
//   '& > img': {
//     maxHeight: 160,
//     border: `1px solid #f2f2f2`,
//     borderRadius: 8,
//   },
//   '&&.selected > img': {
//     borderColor: '#33CCCC',
//     borderWidth: 2,
//   },
// }));

const StyledSelectedImage = styled('img')(({ theme }) => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  border: `1px solid #f2f2f2`,
  borderRadius: 8,
}));

const StyledClearImageButton = styled('button')(({ theme }) => ({
  position: 'absolute',
  right: '0.25rem',
  top: '0.25rem',
  fontSize: '1.5rem',
  color: '#33CCCC',
}));

const postImages = Array.from(Array(6).keys()).map((i, index) => {
  const url = `/user-attachments/neki-celebration-images/${index + 1}.png`;
  return {
    url: url,
    thumbnailUrl: getQualifiedImageUrl(url),
  };
});

function CelebrateDetailsForm(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [userContacts, setUserContacts] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  const {
    post = null,
    template = null,
    setSelectedFile = () => {},
    selectedFile = null,
  } = props;

  const {
    register,
    formState: { errors },
    control,
    reset,
    setValue,
    trigger,
    watch,
  } = useFormContext();

  const { ref: recipientFieldRef, ...recipientField } = register('recipients');

  register('imageUrl');

  const imageUrl = watch('imageUrl');

  const handleImageSelection = (imageUrl) => {
    setSelectedImage(imageUrl);
    setValue('imageUrl', imageUrl, { shouldDirty: true, shouldValidate: true });
  };

  const handleSearch = async (searchText) => {
    setIsLoading(true);

    const query = { search: searchText };
    const { ok, data } = await authorizedServerFetch('users/search', {}, query);
    const responseData = data;
    console.log('handleSearch', responseData);

    if (ok) {
      const userList = responseData.data;
      const contacts = userList?.map((i) => ({
        name: `${i.first_name} ${i.last_name}`,
        id: i.id,
        email: i.email,
      }));
      setUserContacts(contacts);
    }

    setIsLoading(false);
  };

  const getDefaultRecipients = () => {
    if (post) {
      return post.sourcePostData.recipients.map((i) => ({
        name: `${i.profile.first_name} ${i.profile.last_name}`,
        id: i.profile.id,
        email: i.profile.email,
      }));
    }
    return [];
  };

  useEffect(() => {
    const message = post
      ? post.sourcePostData.message
      : template.default_message;

    if (post) {
      reset({
        recipients: getDefaultRecipients(),
        message: message,
        imageUrl: post.sourcePostData.attachmentUrl,
      });
      setSelectedImage(post.sourcePostData.attachmentUrl);
      trigger();
    } else {
      setValue('message', message, { shouldDirty: true, shouldValidate: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form id="celebration-details-form" className="w-full p-2">
      <div className="flex flex-col gap-2">
        <Controller
          control={control}
          name="recipients"
          render={({ field: { value, onChange } }) => (
            <RecipientSelector value={value} onChange={onChange} />
          )}
        />

        <Controller
          control={control}
          name="message"
          render={({ field: { onChange, value } }) => (
            <div>
              <TextArea
                // id="create-celebration-message"
                // noGutters
                label="MESSAGE"
                placeholder="Your message..."
                rows="2"
                value={value}
                onChange={onChange}
                className="bg-[#33CCCC24]"
                error={errors.message?.message}
              />
              {/* {errors.message && (
                <Typography
                  variant="caption"
                  color="error"
                  className="mb-3 mt-0.5">
                  {errors.message.message}
                </Typography>
              )} */}
            </div>
          )}
        />

        {/* <SingleFileSelector
          placeholder="Upload an image or video"
          setSelectedItem={setSelectedFile}
          setValue={setValue}
        />

        <StyledDivider text="OR" /> */}

        <div className="my-2 flex items-center justify-center">
          {selectedImage && (
            <div className="relative rounded-lg border-2 border-gray-200">
              <StyledClearImageButton
                type="button"
                onClick={() => handleImageSelection(null)}>
                <IoMdCloseCircle size={28} />
              </StyledClearImageButton>
              {/* <img
                src={getQualifiedImageUrl(selectedImage)}
                alt="selected-post-background"
              /> */}
              <Image
                src={getQualifiedImageUrl(selectedImage)}
                alt="selected-post-background"
                // layout="responsive"
                width={350}
                height={250}
                className="rounded-lg"
              />
            </div>
          )}
          {!selectedImage && (
            <Stack
              justifyContent="center"
              alignItems="center"
              className="p-3"
              sx={{ border: 1, borderColor: 'gray.main', borderRadius: 2 }}>
              <MdOutlineImage size="2em" />
              <Typography
                variant="body2"
                color={
                  !selectedFile && errors.imageUrl ? 'error' : 'text.primary'
                }>
                Select an image from the gallery below
              </Typography>
            </Stack>
          )}
        </div>
      </div>

      <div className="mt-2 flex flex-wrap justify-center gap-4">
        {postImages.map((image) => (
          <div
            key={image.url}
            className={`w-full cursor-pointer rounded-lg border p-1 transition-transform duration-300 ease-in-out sm:w-1/2 md:w-1/3 lg:w-1/4 ${
              selectedImage === image.url
                ? 'scale-105 border-2 border-teal-500'
                : 'border-gray-200'
            } `}
            role="button"
            onClick={() => handleImageSelection(image.url)}
            onKeyDown={() => handleImageSelection(image.url)}
            tabIndex={0}>
            <Image
              src={image.thumbnailUrl}
              alt="celebration-post-background"
              layout="responsive"
              width={160}
              height={90}
              className="rounded-lg"
            />
          </div>
        ))}
      </div>
    </form>
  );
}

export default CelebrateDetailsForm;
